import state from "./NotificationState";
import {addData, getList, getPage, removeById, updateData} from "@/api/baseApi";
import { Message, MessageBox } from 'element-ui'
import {setDateRange} from "@/utils/common";
import {sendNotification} from "@/api/systemApi";

/**
 * 通知中心数据提供者
 *
 * @author PeterLee
 * @since 2026-03-19
 */
export default {
    namespaced: true,
    state: state,
    getters: {},
    mutations: {
        /** 设置表单弹窗显示 */
        setDialogVisible(state, visible) {
            state.formInfo.dialogVisible = visible;
        },
        /** 点击提交 */
        clickAdd(state) {
            state.formInfo.isAdd = true;
            state.formInfo.dialogVisible = true;
        },
        /** 点击编辑 */
        clickEdit(state, data) {
            state.formInfo.isAdd = false;
            state.formInfo.dialogVisible = true;
            state.formInfo.editData = data;
        },
    },
    actions: {
        /** 添加提交后执行内容(异步网络请求) */
        submitAdd({commit, dispatch}, data) {
            sendNotification(data).then(res => {
                if (res.code === 200) {
                    dispatch('handleTableSearch')
                    Message.success("发送通知成功")
                    commit('setDialogVisible', false)
                }
            });
        },
        /** 删除(异步网络请求)  */
        handleDel({dispatch}, data) {
            MessageBox.confirm('此操作将永久删除该通知, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type:'warning'
            }).then(() => {
                removeById("system", "notification", data.id).then(res => {
                    if (res.code === 200) {
                        dispatch('handleTableSearch')
                        Message.success("删除成功！")
                    }
                })
            }).catch(() => {
                Message.info("已取消删除")
            });
        },
        /** 处理表格查询(异步网络请求)  */
        handleTableSearch({state}) {
            state.queryParams.pageNum = 1;
            let param = state.queryParams;
            for (let key in state.dateRange) {
                param = setDateRange(param, state.dateRange[key], key);
            }
            getPage("system", "notification", param).then(res => {
                if (res.code === 200) {
                    state.tableData = res.data.list;
                    state.totalCount = res.data.totalCount;
                }
            })
        },
        /** 编辑提交后执行内容 (异步网络请求)*/
        submitEdit({commit, dispatch}, data) {
            updateData("system", "notification", data).then(res => {
                if (res.code === 200) {
                    dispatch('handleTableSearch')
                    Message.success("修改通知信息成功")
                    commit('setDialogVisible', false)
                }
            });
        },
    },
    modules: {}
}
